/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloorPlanDto } from '../../models/floor-plan-dto';
import { UpdateFloorPlanDto } from '../../models/update-floor-plan-dto';

export interface FloorPlanControllerUpdateV1$Params {
  id: string;
      body: UpdateFloorPlanDto
}

export function floorPlanControllerUpdateV1(http: HttpClient, rootUrl: string, params: FloorPlanControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorPlanDto>> {
  const rb = new RequestBuilder(rootUrl, floorPlanControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloorPlanDto>;
    })
  );
}

floorPlanControllerUpdateV1.PATH = '/api/v1/floor-plan/{id}';
